/*  @flow */

import { allRoles, modelMastersAdmin, userManagement } from 'permissions/general';
import * as reportingPermissions from 'permissions/reporting';
import * as customerAccountsPermissions from 'permissions/customerAccounts';
import { ENV } from '../../../../config';

const getURLForMyER = () => {
  switch (ENV) {
    case 'production':
      return 'https://www.electrorent.com/my-account/dashboard';
    case 'staging':
      return 'https://www2-stage.electrorent.com/my-account/dashboard';
    case 'uat':
    default:
      return 'https://www2-uat.electrorent.com/my-account/dashboard';
  }
};

const leftMenuLinks: Array<*> = [
  {
    to: '/welcome-page',
    alias: '/',
    label: 'general:welcome_page.menu_item',
    icon: '#icon-home',
    permissions: allRoles,
  },
  {
    to: '/dashboard',
    label: 'general:dashboard',
    icon: '#icon-dashboard',
    permissions: allRoles,
  },
  {
    to: '/accounts',
    label: 'general:trading_account_plural',
    icon: '#icon-trading-accounts',
    permissions: allRoles,
  },
  {
    to: '/orders',
    label: 'general:contract_left_menu_plural',
    icon: '#icon-contracts',
    permissions: allRoles,
  },
  {
    to: '/assets',
    label: 'general:asset_plural',
    icon: '#icon-assets',
    permissions: allRoles,
  },
  {
    to: '/projects',
    label: 'general:project_plural',
    icon: '#icon-projects',
    permissions: allRoles,
  },
  {
    to: '/cost-centers',
    label: 'general:cost_center_plural',
    icon: '#icon-cost-centers',
    permissions: allRoles,
  },
  {
    to: '/model-masters',
    label: 'general:model_master_plural',
    icon: '#icon-model-master',
    permissions: modelMastersAdmin,
  },
  {
    to: '/users',
    label: 'general:user_management',
    icon: '#icon-users',
    permissions: userManagement,
  },
  {
    to: '/reporting',
    label: 'general:reporting.nav_title',
    icon: '#icon-bar-chart',
    permissions: reportingPermissions.viewAllBrands,
  },
  {
    to: '/customer-accounts',
    label: 'general:customer_accounts.nav_title',
    icon: '#icon-institution',
    permissions: customerAccountsPermissions.read,
  },
  {
    to: '/support',
    label: 'general:support_request',
    icon: '#icon-help',
    permissions: allRoles,
  },
  {
    to: getURLForMyER(),
    absolute: true,
    className: 'myERLink',
    label: 'general:er_title',
    icon: '#icon-arrow',
    permissions: customerAccountsPermissions.read,
  },
];

export default leftMenuLinks;
